<div class="container-fluid">
  <div class="row d-flex justify-content-start align-items-center">
    <button class="nav-back" [routerLink]="['/readiness-import', projectId]"><fa-icon [icon]="faChevronLeft"
        size="lg"></fa-icon></button>
    <h1 class="title">{{titleValue}}</h1>
  </div>
</div>

<div class="container readiness-admin-form-container mt-4 d-none">
  <div class="card shadow-lg p-4">
    <h3 class="text-center mb-4">Readiness Form - Column Settings</h3>

    <div class="mb-3">
      <label for="menuSelect" class="form-label">Select Column</label>
      <select id="menuSelect" class="form-control" [(ngModel)]="selectedMenu">
        <option *ngFor="let menu of menuList" [value]="menu">{{ menu }}</option>
      </select>
    </div>

    <div class="form-check mb-3">
      <input class="form-check-input" type="checkbox" id="isActive" [(ngModel)]="isActive">
      <label class="form-check-label mx-1" for="isActive">Is Active</label>
    </div>

    <div class="form-check mb-3">
      <input class="form-check-input" type="checkbox" id="isRequired" [(ngModel)]="isRequired">
      <label class="form-check-label mx-1" for="isRequired">Is Required</label>
    </div>

    <button class="btn btn-primary w-100" (click)="saveNewSettings()">Save</button>
  </div>
</div>

<div class="container-fluid mt-4">
  <div class="card shadow-sm p-4">
    <div class="table-responsive">
      <div style="display: flex; justify-content: end;">

        <a [routerLink]="['/readiness-form-column-settings', projectId]" title="Settings">
          <button class="btn mb-2 mx-2">
            Column Settings
          </button>
        </a>

        <button class="btn mb-2" (click)="saveAllTableData()">Save All</button>
      </div>
      <div *ngFor="let group of groupedData; let sectionIndex = index">
        <div class="section-header" (click)="toggleCategory(group.sectionName)" draggable="true"
          (dragstart)="onSectionDragStart($event, sectionIndex)" (dragover)="onSectionDragOver($event)"
          (drop)="onSectionDrop($event, sectionIndex)">
          <div class="col-md-4">
            <span>
              {{ group.sectionName }}
              <fa-icon [icon]="categoryToggle[group.sectionName] ? faChevronDown : faChevronRight" size="lg"></fa-icon>
            </span>
          </div>

          <div class="col-md-7">
            <div *ngIf="sectionIndex != 0 && group.sectionName != 'Other'" class="traffic-light-rules" style="display: flex;">
              <div *ngFor="let rule of trafficLightRulesBySection[group.sectionName]" style="margin-right: 25px; width: 125px;">
                <span [style.background]="rule.Color"
                  style="display: inline-block; width: 16px; height: 16px; border-radius: 50%; margin-right: 4px;">
                </span>
                <small>When value is</small>
                <span>{{ rule.Operator }}  {{ rule.ThresholdValue }}</span>
              </div>
            </div>
          </div>

          <div>
            <span *ngIf="sectionIndex != 0 && group.sectionName != 'Other'" title="Settings"
              (click)="openColorSettings($event, group.sectionName)"><fa-icon [icon]="faCog"></fa-icon></span>
          </div>
        </div>

        <table class="table table-bordered table-hover" *ngIf="categoryToggle[group.sectionName]"
          style="margin-top: 10px;">
          <thead style="background-color: #3f84c0; color: white;">
            <tr>
              <th>Display Name</th>
              <th class="column-3">
                <span (click)="sortAllRows(group.sectionName, 'IsVisible')">
                  Is Visible
                </span>
                <span *ngIf="sortOrderForIsVisible(group.sectionName) !== null">
                  <fa-icon [icon]="sortOrderForIsVisible(group.sectionName) === 'asc' ? faArrowUp : faArrowDown"
                    size="lg" style="color: white;"></fa-icon>
                </span>
                <span class="group-by-icon" (click)="sortAllRows(group.sectionName, 'IsVisible')"
                  style="cursor: pointer; display: none;">
                  <fa-icon [icon]="faSort" size="lg" style="color: white;"></fa-icon>
                </span>
                <!-- <span class="group-by-icon" (click)="groupByColumn('IsVisible')" title="Group by IsVisible"
                style="float: inline-end; cursor: pointer; display: none;">
                <fa-icon [icon]="faLayerGroup" size="lg" style="color: white;"></fa-icon>
              </span> -->
              </th>
              <th class="column-3">
                <span (click)="sortAllRows(group.sectionName, 'IsRequired')">
                  Is Required
                </span>
                <span *ngIf="sortOrderForIsRequired(group.sectionName) !== null">
                  <fa-icon [icon]="sortOrderForIsRequired(group.sectionName) === 'asc' ? faArrowUp : faArrowDown"
                    size="lg" style="color: white;"></fa-icon>
                </span>
                <span class="group-by-icon" (click)="sortAllRows(group.sectionName, 'IsRequired')"
                  style="cursor: pointer; display: none;">
                  <fa-icon [icon]="faSort" size="lg" style="color: white;"></fa-icon>
                </span>
              </th>
              <th class="column-3">
                Contribue to Traffic light
              </th>
              <th class="column-3">
                Value
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let column of group.data; let i = index" draggable="true"
              (dragstart)="onRowDragStart($event, i, group.sectionName)" (dragover)="onRowDragOver($event)"
              (drop)="onRowDrop($event, i, group.sectionName)" class="draggable-row">
              <td>{{ column.DisplayName }}</td>
              <td>
                <input type="checkbox" [(ngModel)]="column.IsVisible" class="readiness-admin-input readiness-checkbox" />
              </td>
              <td>
                <input type="checkbox" [(ngModel)]="column.IsRequired" class="readiness-admin-input readiness-checkbox" />
              </td>
              <td>
                <input type="checkbox" [(ngModel)]="column.RequiredInFormula" class="readiness-admin-input readiness-checkbox" />
              </td>
              <td>
                <input type="number" [(ngModel)]="column.Value" class="form-control" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>